import Stack, { StackProps } from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import * as Device from 'react-device-detect';

export interface FormBodyProps extends StackProps {
  children: React.ReactNode;
}

export const FormBody = (props: FormBodyProps) => {
  const { children, sx } = props;

  return (
    <Stack
      width="100%"
      spacing={2}
      divider={<Divider />}
      sx={{
        px: 2,
        pt: Device.isMobileOnly ? 10 : 0,
        pb: Device.isMobileOnly ? 'calc(env(safe-area-inset-bottom) + 60px)' : 2,
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};
